'use client';

import { cn } from '../../libs/utils';
import { TextButton } from '../button';

import { Toast, ToastProvider, ToastTitle, ToastViewport } from './toast';
import { useToast } from './useToast';
import { getToastIcon } from './util/getToastIcon';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, button, icon, duration = 3000, autoClose = true, open, variant, onClick, ...props }) => (
        <Toast
          key={id}
          {...props}
          duration={autoClose ? duration : 10 ** 10}
          open={open}
          onPause={() => {
            if (!autoClose || button) return;
            setTimeout(() => {
              dismiss();
            }, 1000);
          }}
        >
          <div className={cn('flex items-center gap-tiny-large py-normal-medium')}>
            {getToastIcon(variant)}
            {title && <ToastTitle>{title}</ToastTitle>}
          </div>
          {button && (
            <TextButton variant={'inverse'} size={'xsmall'} className={'label-xsmall-medium text-neutral-foreground-inverse-main'} onClick={onClick}>
              {button}
            </TextButton>
          )}
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
